import React from 'react';
import PropTypes from 'prop-types';
import { get, reject } from 'lodash';

import DateWithHover from 'components/timestamps/date_with_hover';

export const NAME = 'contactName';
export const COMPANY = 'contactCompany';
export const RELATIONSHIP = 'relationshipLabel';
export const EMAIL = 'email';
export const MOBILE_PHONE = 'mobilePhone';
export const WORK_PHONE = 'officePhone';
export const JOB_TITLE = 'jobTitle';
export const LAST_CONTACTED = 'lastContacted';

export const COLUMN_DEFINITIONS = {
  [NAME]: { title: 'Name', sortValue: 'contactName' },
  [COMPANY]: { title: 'Company', sortValue: 'contactCompany' },
  [EMAIL]: { title: 'Email', sortValue: 'email' },
  [MOBILE_PHONE]: { title: 'Mobile Phone', sortValue: 'mobilePhone' },
  [WORK_PHONE]: { title: 'Work Phone', sortValue: 'officePhone' },
  [JOB_TITLE]: { title: 'Job Title', sortValue: 'jobTitle' },
  [LAST_CONTACTED]: { title: 'Last Contacted', sortValue: 'lastContacted' },
  [RELATIONSHIP]: { title: 'Relation', sortValue: 'relationshipLabel' }
};

export const CONFIGURABLE_COLUMNS = reject(Object.keys(COLUMN_DEFINITIONS), column => column === NAME);

function EmptyCell() {
  return <span>--</span>;
}

function SimpleCell({ content, isDate }) {
  if (!content) return <EmptyCell />;
  if (isDate) return <DateWithHover timestamp={content} />;

  return <React.Fragment>{content}</React.Fragment>;
}
SimpleCell.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isDate: PropTypes.bool
};

export default function Cell({ contactPerson, columnName }) {
  let cellContent;

  if (Cell[columnName]) {
    const CellComponent = Cell[columnName];
    cellContent = <CellComponent contactPerson={contactPerson} />;
  } else {
    const { sortValue, type } = COLUMN_DEFINITIONS[columnName];
    cellContent = <SimpleCell content={get(contactPerson, sortValue)} isDate={type === 'date'} />;
  }

  return <td>{cellContent}</td>;
}
Cell.propTypes = {
  columnName: PropTypes.string.isRequired,
  contactPerson: PropTypes.object.isRequired
};

function CompanyCell({ contactPerson }) {
  if (!contactPerson.contactCompany) return <EmptyCell />;

  const companyName = <strong>{contactPerson.contactCompany}</strong>;
  return contactPerson.contactCompanyPath ? <a href={contactPerson.contactCompanyPath}>{companyName}</a> : companyName;
}
CompanyCell.propTypes = {
  contactPerson: PropTypes.shape({
    contactCompany: PropTypes.string,
    contactCompanyPath: PropTypes.string
  }).isRequired
};

function ContactNameCell({ contactPerson }) {
  const name = <strong>{contactPerson.contactName}</strong>;

  return <div className="contact-name" title={contactPerson.contactName}>
    {contactPerson.contactPath ? <a href={contactPerson.contactPath}>{name}</a> : name}
  </div>;
}
ContactNameCell.propTypes = {
  contactPerson: PropTypes.shape({
    contactName: PropTypes.string.isRequired,
    contactPath: PropTypes.string
  }).isRequired
};

Cell[COMPANY] = CompanyCell;
Cell[NAME] = ContactNameCell;
